export { default as CorporateContactEditTemplate } from './CorporateContactEdit';